import { css } from "@emotion/react";
import { FC } from "react";

import { Avatar } from "@livechat/design-system-react-components";

interface IProps extends React.HTMLAttributes<HTMLElement> {
  teamId: string;
  teamName: string;
  removable?: boolean;
}

const TeamBaseItem: FC<IProps> = ({ teamName, removable, ...restProps }) => (
  <div css={containerCSS} {...restProps}>
    <Avatar type="text" text={teamName} shape="rounded-square" size="xsmall" css={{ minWidth: "24px" }} />
    <span title={teamName} css={teamNameCSS(removable)}>
      {teamName}
    </span>
  </div>
);

export const TeamSelectItem: React.FC<IProps> = props => <TeamBaseItem {...props} removable />;
export const TeamHeaderItem: React.FC<IProps> = props => <TeamBaseItem {...props} removable={false} />;

const containerCSS = css`
  width: 100%;
  font-size: 14px;
  line-height: 1.3;
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const teamNameCSS = (removable?: boolean) => css`
  margin-left: 6px;
  width: ${removable ? "calc(100% - 30px)" : "100%"};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
`;
